import { Navigate } from "react-router-dom";
import { SafeOutlet } from "@/shared/components/ErrorBoundary";
import { AdminPatientsProvider } from "@/portals/admin/context/AdminPatientsContext";
import { useAdminAuthStore } from "@/stores/adminAuthStore";
import { AdminLayout } from "@/portals/admin/layout/AdminLayout";
import { useIdleLogout } from "@/portals/admin/hooks/useIdleLogout";
import { PageSpinner } from "@/shared/components/spinner";
import { AppQueryProvider } from "@/lib/query/AppQueryProvider";

function SessionLoader() {
  return (
    <div className="bg-white">
      <PageSpinner fullScreen />
    </div>
  );
}

export function AdminProtectedLayout() {
  const isAuthenticated = useAdminAuthStore((s) => s.isAuthenticated);
  const isLoading = useAdminAuthStore((s) => s.isLoading);
  useIdleLogout();

  if (isLoading) return <SessionLoader />;
  if (!isAuthenticated) return <Navigate to="/admin/signin" replace />;

  // Server-data cache for this session only — unmounted (and emptied) on logout.
  return (
    <AppQueryProvider>
      <AdminPatientsProvider>
        <AdminLayout>
          <SafeOutlet />
        </AdminLayout>
      </AdminPatientsProvider>
    </AppQueryProvider>
  );
}
